import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import { ScrollManager } from "./components/ScrollManager";
import { Seo } from "./seo/Seo";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Process } from "./components/Process";
import { Work } from "./components/Work";
import { CaseStudies } from "./components/CaseStudies";
import { VideoWorks } from "./components/VideoWorks";
import { TrustedBy } from "./components/TrustedBy";
import { InstaStrip } from "./components/InstaStrip";
import { Pricing } from "./components/Pricing";
import { Faq } from "./components/Faq";
import { Contact } from "./components/Contact";
import AboutPage from "./components/pages/AboutPage";
import ContactPage from "./components/pages/ContactPage";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import NotFound from "./components/pages/NotFound";
import Admin from "./components/Admin";

const Home = () => (
  <Layout>
    <Seo path="/" />
    <Hero />
    <About />
    <Services />
    <Process />
    <Work />
    <CaseStudies />
    <VideoWorks />
    <TrustedBy />
    <InstaStrip />
    <Pricing />
    <Faq />
    <Contact />
  </Layout>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/admin" element={<><Seo path="/admin" /><Admin /></>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
